/** Shopify CDN: Minification failed

Line 123:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 124:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 125:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 126:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 127:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 129:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 130:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 131:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 133:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 134:0 Transforming let to the configured target environment ("es5") is not supported yet
... and 12 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 108:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 109:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 110:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 111:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 112:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 114:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 115:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 116:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 118:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 119:0 Transforming let to the configured target environment ("es5") is not supported yet
... and 12 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 93:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 94:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 95:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 96:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 97:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 99:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 100:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 101:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 103:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 104:0 Transforming let to the configured target environment ("es5") is not supported yet
... and 12 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 78:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 79:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 80:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 81:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 82:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 84:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 85:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 86:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 88:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 89:0 Transforming let to the configured target environment ("es5") is not supported yet
... and 12 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 63:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 64:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 65:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 66:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 67:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 69:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 70:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 71:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 73:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 74:0 Transforming let to the configured target environment ("es5") is not supported yet
... and 12 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 48:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 49:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 50:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 51:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 52:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 54:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 55:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 56:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 58:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 59:0 Transforming let to the configured target environment ("es5") is not supported yet
... and 12 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 33:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 34:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 35:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 36:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 37:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 39:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 40:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 41:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 43:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 44:0 Transforming let to the configured target environment ("es5") is not supported yet
... and 12 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 18:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 19:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 20:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 21:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 22:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 24:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 25:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 26:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 28:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 29:0 Transforming let to the configured target environment ("es5") is not supported yet
... and 12 more hidden warnings

**/
/*! instant.page v3.0.0 - (C) 2019 Alexandre Dieulot - https://instant.page/license */

let mouseoverTimer
let lastTouchTimestamp
const prefetches = new Set()
const prefetchElement = document.createElement('link')
const isSupported = prefetchElement.relList && prefetchElement.relList.supports && prefetchElement.relList.supports('prefetch')
    && window.IntersectionObserver && 'isIntersecting' in IntersectionObserverEntry.prototype
const allowQueryString = 'instantAllowQueryString' in document.body.dataset
const allowExternalLinks = 'instantAllowExternalLinks' in document.body.dataset
const useWhitelist = 'instantWhitelist' in document.body.dataset

let delayOnHover = 65
let useMousedown = false
let useMousedownOnly = false
let useViewport = false
if ('instantIntensity' in document.body.dataset) {
    const intensity = document.body.dataset.instantIntensity

    if (intensity.substr(0, 'mousedown'.length) == 'mousedown') {
        useMousedown = true
        if (intensity == 'mousedown-only') {
            useMousedownOnly = true
        }
    }
    else if (intensity.substr(0, 'viewport'.length) == 'viewport') {
        if (!(navigator.connection && (navigator.connection.saveData || navigator.connection.effectiveType.includes('2g')))) {
            if (intensity == "viewport") {
                /* Biggest iPhone resolution (which we want): 414 × 896 = 370944
                 * Small 7" tablet resolution (which we don’t want): 600 × 1024 = 614400
                 * Note that the viewport (which we check here) is smaller than the resolution due to the UI’s chrome */
                if (document.documentElement.clientWidth * document.documentElement.clientHeight < 450000) {
                    useViewport = true
                }
            }
            else if (intensity == "viewport-all") {
                useViewport = true
            }
        }
    }
    else {
        const milliseconds = parseInt(intensity)
        if (!isNaN(milliseconds)) {
            delayOnHover = milliseconds
        }
    }
}

if (isSupported) {
    const eventListenersOptions = {
        capture: true,
        passive: true,
    }

    if (!useMousedownOnly) {
        document.addEventListener('touchstart', touchstartListener, eventListenersOptions)
    }

    if (!useMousedown) {
        document.addEventListener('mouseover', mouseoverListener, eventListenersOptions)
    }
    else {
        document.addEventListener('mousedown', mousedownListener, eventListenersOptions)
    }

    if (useViewport) {
        let triggeringFunction
        if (window.requestIdleCallback) {
            triggeringFunction = (callback) => {
                requestIdleCallback(callback, {
                    timeout: 1500,
                })
            }
        }
        else {
            triggeringFunction = (callback) => {
                callback()
            }
        }

        triggeringFunction(() => {
            const intersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const linkElement = entry.target
                        intersectionObserver.unobserve(linkElement)
                        preload(linkElement.href)
                    }
                })
            })

            document.querySelectorAll('a').forEach((linkElement) => {
                if (isPreloadable(linkElement)) {
                    intersectionObserver.observe(linkElement)
                }
            })
        })
    }
}

function touchstartListener(event) {
    /* Chrome on Android calls mouseover before touchcancel so `lastTouchTimestamp`
     * must be assigned on touchstart to be measured on mouseover. */
    lastTouchTimestamp = performance.now()

    const linkElement = event.target.closest('a')

    if (!isPreloadable(linkElement)) {
        return
    }

    preload(linkElement.href)
}

function mouseoverListener(event) {
    if (performance.now() - lastTouchTimestamp < 1100) {
        return
    }

    const linkElement = event.target.closest('a')

    if (!isPreloadable(linkElement)) {
        return
    }

    linkElement.addEventListener('mouseout', mouseoutListener, { passive: true })

    mouseoverTimer = setTimeout(() => {
        preload(linkElement.href)
        mouseoverTimer = undefined
    }, delayOnHover)
}

function mousedownListener(event) {
    const linkElement = event.target.closest('a')

    if (!isPreloadable(linkElement)) {
        return
    }

    preload(linkElement.href)
}

function mouseoutListener(event) {
    if (event.relatedTarget && event.target.closest('a') == event.relatedTarget.closest('a')) {
        return
    }

    if (mouseoverTimer) {
        clearTimeout(mouseoverTimer)
        mouseoverTimer = undefined
    }
}

function isPreloadable(linkElement) {
    if (!linkElement || !linkElement.href) {
        return
    }

    if (useWhitelist && !('instant' in linkElement.dataset)) {
        return
    }

    if (!allowExternalLinks && linkElement.origin != location.origin && !('instant' in linkElement.dataset)) {
        return
    }

    if (!['http:', 'https:'].includes(linkElement.protocol)) {
        return
    }

    if (linkElement.protocol == 'http:' && location.protocol == 'https:') {
        return
    }

    if (!allowQueryString && linkElement.search && !('instant' in linkElement.dataset)) {
        return
    }

    if (linkElement.hash && linkElement.pathname + linkElement.search == location.pathname + location.search) {
        return
    }

    if ('noInstant' in linkElement.dataset) {
        return
    }

    return true
}

function preload(url) {
    if (prefetches.has(url)) {
        return
    }

    const prefetcher = document.createElement('link')
    prefetcher.rel = 'prefetch'
    prefetcher.href = url
    document.head.appendChild(prefetcher)

    prefetches.add(url)
}